import React from 'react';
import { 
  HelpCircle, 
  TrendingUp, 
  DollarSign, 
  FileText, 
  Shield, 
  Users, 
  Briefcase 
} from 'lucide-react';

const TipsSidebar = () => {
  const tips = [
    {
      icon: TrendingUp,
      title: 'Управление ликвидностью',
      description: 'Поддерживайте достаточный уровень оборотного капитала для покрытия краткосрочных обязательств.'
    },
    {
      icon: DollarSign,
      title: 'Оптимизация долга',
      description: 'Стремитесь к оптимальной структуре капитала с соотношением заемных и собственных средств не более 60/40.'
    },
    {
      icon: FileText,
      title: 'Мониторинг показателей',
      description: 'Регулярно отслеживайте ключевые финансовые коэффициенты и их динамику.'
    },
    {
      icon: Shield,
      title: 'Диверсификация рисков',
      description: 'Диверсифицируйте источники дохода, клиентскую базу и поставщиков для снижения рисков.'
    },
    {
      icon: Users,
      title: 'Работа с дебиторами',
      description: 'Внедрите эффективную систему управления дебиторской задолженностью для улучшения денежного потока.'
    },
    {
      icon: Briefcase,
      title: 'Финансовое планирование',
      description: 'Составляйте реалистичные финансовые прогнозы с учетом возможных негативных сценариев.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-orange-500" />
        Советы по финансовой устойчивости
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-orange-500 mt-0.5 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Антикризисное управление
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              При высоком риске банкротства разработайте план антикризисных мероприятий с привлечением профессиональных консультантов.
            </p>
            <button className="w-full py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">
              Получить консультацию
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;